export const isReferrer = (referrer: string): boolean => {
  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get('referrer') === referrer;
};
